// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1r89j","paramInput":"JobSimulator_paramInput__v7Al_","input":"JobSimulator_input__3ppv4"};